

















import mixins from 'vue-typed-mixins';
import FunctionalCenterForm from '@/components/functionalcenter/FunctionalCenterForm.vue';
import FunctionalCenterUtils, {
  FunctionalCenter,
} from '@/utils/FunctionalCenterUtils';
export default mixins().extend({
  components: {
    FunctionalCenterForm,
  },
  data(): {
    functionalcenter?: Partial<FunctionalCenter>;
  } {
    return {
      functionalcenter: undefined,
    };
  },
  mounted() {
    this.functionalcenter = {
      id: undefined,
      code: undefined,
    };
  },
  methods: {
    async submit() {
      try {
        if (this.functionalcenter) {
          this.$alert.hide('submit');
          await FunctionalCenterUtils.api.add(this.functionalcenter);
          await this.$router.push({ name: 'functional-center-list' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.$languageobj('model.functionalcenter.label')],
            }),
          });
        }
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
